class MainRegisterActivation {
  constructor() {
    this.storageKey = 'dreambabyMainRegisterEmail';

    this.form = document.getElementById('create_customer');
    if (!this.form) {
      return;
    }

    this.isGoodiebagFlow = Boolean(this.form.closest('.dreambaby-goodiebag'));
    this.passwordInput = this.form.querySelector('input[name="customer[password]"]');
    this.emailInput = this.form.querySelector('input[name="customer[email]"]');
    this.successMessage = document.getElementById('register-success-message');

    this.customerMailHandler = new DreambabyCustomerMailHandler({});

    this.init();
  }

  init() {
    this.generateRandomPassword();
    this.setupEmailTracking();
    this.handleSuccessfulRegistration();
  }

  generateRandomPassword() {
    if (!this.passwordInput) {
      return;
    }

    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    this.passwordInput.value = Array(20)
      .fill()
      .map(() => chars.charAt(Math.floor(Math.random() * chars.length)))
      .join('');
  }

  setupEmailTracking() {
    if (!this.emailInput) {
      return;
    }

    if (this.emailInput.value) {
      sessionStorage.setItem(this.storageKey, this.emailInput.value);
    }

    this.emailInput.addEventListener('input', (event) => {
      sessionStorage.setItem(this.storageKey, event.target.value);
    });

    this.form.addEventListener('submit', () => {
      this.generateRandomPassword();
      sessionStorage.setItem(this.storageKey, this.emailInput.value);
    });
  }

  handleSuccessfulRegistration() {
    const wasPosted = window.location.search.includes('registration_posted=true');
    const hasErrors = Array.from(document.querySelectorAll('.form-message--error')).some(
      (element) => !element.closest('.form-errors-modal')
    );

    if (wasPosted) {
      window.history.replaceState(null, '', window.location.pathname);
    }

    if (!wasPosted || hasErrors) {
      return;
    }

    if (this.isGoodiebagFlow) {
      return;
    }

    const email = sessionStorage.getItem(this.storageKey);

    this.form.style.display = 'none';
    if (this.successMessage) {
      this.successMessage.style.display = 'block';
    }

    this.logoutCustomer();

    if (email) {
      setTimeout(() => {
        this.customerMailHandler.triggerResetPassword(email);
        sessionStorage.removeItem(this.storageKey);
      }, 1500);
    }
  }

  logoutCustomer() {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = '/account/logout';
    document.body.appendChild(iframe);

    setTimeout(() => {
      if (iframe && iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    }, 1000);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new MainRegisterActivation();
});
